import { Icon20DocumentOutline, Icon20FolderSimplePlusOutline, Icon24SearchStarsOutline } from '@vkontakte/icons';
import { Spacing } from '@vkontakte/vkui';
import image from 'img/usedSpacePostpaid/processing.png';
import imageDark from 'img/usedSpacePostpaid/processing-dark.png';
import React from 'react';
import {
    aiOrganizePromoFakedoorVariant,
    isCVariantAiOrganizeFakedoor,
    videoUrlAiOrganize,
} from 'reactApp/appHelpers/featuresHelpers/features/fakedoorNeuroOrganizePromo';
import type { IProps } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { sendDwhModal } from 'reactApp/modules/dwh/dwh.helpers';
import { markFakedoorIsCompleteByModalClick } from 'reactApp/ui/FakedoorNeuroOrganizePromo/utils';

import styles from './FakedoorNeuroOrganizerDialog.css';

const buttonText = isCVariantAiOrganizeFakedoor ? 'Попробовать' : 'Попробовать за 1 ₽';

const name = `mnz_ai_organize_fakedoor_${aiOrganizePromoFakedoorVariant || 'n'}`;
const nameOk = 'mnz_ai_organize_fakedoor_ok';

export const renderFakedoorNeuroOrganizerDialog = ({
    hide = undefined,
    complete = undefined,
    isDarkTheme = false,
    isByClick = false,
}: {
    hide?(): void;
    complete?(): void;
    isDarkTheme?: boolean;
    isByClick?: boolean;
} = {}) => {
    const primaryClickHandler = () => {
        sendDwhModal({ name, action: 'click', data: { byclick: isByClick } });
        if (complete) {
            complete?.();
        }

        markFakedoorIsCompleteByModalClick();

        setTimeout(
            () =>
                renderCommonWhatsNewDialog({
                    title: 'Спасибо за интерес',
                    content: (
                        <>
                            <Spacing size={12} />
                            <div className={styles.description}>Мы ещё работаем над этими возможностями. Сообщим сразу, как появятся</div>
                            <Spacing size={24} />
                        </>
                    ),
                    secondaryButtonText: 'Закрыть',
                    imageUrl: isDarkTheme ? imageDark : image,
                    onShow: () => {
                        sendDwhModal({ name: nameOk });
                    },
                    dialogSize: 'tiny',
                    buttonTheme: 'vk',
                    closeAfterClick: true,
                    className: styles.root,
                    contentClassName: styles.content,
                    qaId: 'ai-organize-fakedoor-ok',
                }),
            250
        );
    };

    const config: IProps = {
        title: (
            <div className={styles.title}>
                Быстрый поиск и порядок с нейросетью
                <br />в Облаке
            </div>
        ),
        content: (
            <>
                <Spacing size={4} />
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <Icon24SearchStarsOutline width={20} height={20} />
                    </div>
                    <div className={styles.text}>Найдёт фото или документ — опишите по памяти, что там было</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <Icon20DocumentOutline />
                    </div>
                    <div className={styles.text}>Перескажет содержимое — наведите курсор на папку</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.icon}>
                        <Icon20FolderSimplePlusOutline />
                    </div>
                    <div className={styles.text}>Разложит по категориям — вам надо только загрузить файлы</div>
                </div>
                <Spacing size={24} />
            </>
        ),
        primaryButtonText: buttonText,
        imageUrl: '',
        imageWrapperClassName: styles.wrapper,
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: <video src={videoUrlAiOrganize} autoPlay muted loop className={styles.video} />,
        onClick: primaryClickHandler,
        onDismiss: () => {
            sendDwhModal({ name, action: 'close', data: { byclick: isByClick } });
            hide?.();
        },
        onShow: () => {
            sendDwhModal({ name, data: { byclick: isByClick } });
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        closeAfterClick: true,
        className: styles.root,
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        qaId: 'ai-organize-fakedoor-modal',
    };

    renderCommonWhatsNewDialog(config);
};
